import RichTextInput from 'ra-input-rich-text';
import React from 'react';
import { SimpleForm, required, SimpleFormIterator, FormDataConsumer, FunctionField } from 'react-admin';

import CustomArrayInput from '../../../commonComponents/CustomArrayInput';
import FormIterator from '../../../core/FormIterator';
import { quizzesQuestionTypes, s3FilePaths } from '../../../config/constants';
import ImageInput from '../../../commonComponents/UploadInputs/ImageInput';
import PersonalityQuizQuestion from '../../../commonComponents/PersonalityQuizQuestion';
import UploadFileInput from '../../../commonComponents/UploadInputs/UploadFileInput';
import TruncatedArrayDisplay from '../../../commonComponents/TruncatedArrayDisplay';

const pushNewField = ({ fields, nextFormType: questionTypeId }) => {
  fields.push({ type_id: questionTypeId, answers: Array(4).fill({}) });
};

const renderForm = ({ field, member }) => {
  const component = <PersonalityQuizQuestion member={member} questionFormType={field.type_id} />;

  return component;
};

const PersonalityQuizForm = ({ children, quizType, ...rest }) => (
  <SimpleForm {...rest}>
    {children}
    <CustomArrayInput source="questions">
      <FormIterator
        formTypeTogglerOptions={[{ value: quizzesQuestionTypes.personality, label: 'Personality question' }]}
        renderForm={renderForm}
        pushNewField={pushNewField}
        formTypeTogglerLabel="Question type"
        quizType={quizType}
      />
    </CustomArrayInput>
    <CustomArrayInput source="results" label="Results">
      <SimpleFormIterator disableReordering getItemLabel={() => undefined}>
        <FormDataConsumer>
          {({ getSource, scopedFormData }) => (
            <>
              <UploadFileInput
                fileInputSource={getSource('answer_pattern_file_url')}
                label="Answer Patterns"
                parse={(file) => {
                  // If file is a string (URL), convert to object format expected by FileInputPreview
                  if (typeof file === 'string') {
                    return { url: file, name: file.split('/').pop() || 'file' };
                  }
                  return file;
                }}
                format={(file) => {
                  // If file is a string (URL), convert to object format expected by FileInputPreview
                  if (typeof file === 'string') {
                    return { url: file, name: file.split('/').pop() || 'file' };
                  }
                  return file;
                }}
              />
              {/* We're in FormDataConsumer context, so we can't simply use ArrayField */}
              <FunctionField
                label="Current Answer Patterns"
                render={() => (
                  // So we can display multiple hundreds of values
                  <TruncatedArrayDisplay
                    items={scopedFormData?.patterns || []}
                    label="Answer Patterns"
                    emptyMessage="No answer patterns uploaded yet"
                    showNumbers={false}
                  />
                )}
              />
              <div style={{ minWidth: '640px', width: '100%' }}>
                <RichTextInput
                  source={getSource('text1')}
                  label="First Screen Text"
                  validate={[required()]}
                  fullWidth={true}
                />
              </div>
              <div style={{ minWidth: '640px', width: '100%' }}>
                <RichTextInput
                  source={getSource('text2')}
                  label="Second Screen Text"
                  validate={[required()]}
                  fullWidth={true}
                />
              </div>
              <ImageInput
                imagePath={s3FilePaths.quiz}
                imageInputSource={getSource('image')}
                label="Result Image"
                validate={required()}
              />
            </>
          )}
        </FormDataConsumer>
      </SimpleFormIterator>
    </CustomArrayInput>
    <div style={{ width: '640px' }}>
      <RichTextInput
        source="default_result.text1"
        label="Default result 1st screen text"
        validate={[required()]}
        fullWidth={true}
      />
    </div>
    <div style={{ width: '640px' }}>
      <RichTextInput
        source="default_result.text2"
        label="Default result 2nd screen text"
        validate={[required()]}
        fullWidth={true}
      />
    </div>
    <ImageInput
      imagePath={s3FilePaths.quiz}
      imageInputSource="default_result.image"
      label="Default Result Image"
      validate={required()}
    />
  </SimpleForm>
);

export default PersonalityQuizForm;
